import { render, staticRenderFns } from "./userVip.vue?vue&type=template&id=54e201e8&scoped=true"
import script from "./userVip.vue?vue&type=script&lang=js"
export * from "./userVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e201e8",
  null
  
)

export default component.exports